module.exports = __webpack_public_path__ + "img/promo-md.66985845.png";